import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BoldButton } from './SnackbarStyles';

const RefreshPageToast = ({ message, events }) => {
  const { t } = useTranslation();

  const handleRefresh = useCallback(() => {
    const { onRefresh } = events;
    onRefresh && onRefresh();
    window.location.reload();
  }, [events]);

  const handleDismiss = useCallback(() => {
    const { onDismiss } = events;
    onDismiss && onDismiss();
  }, [events]);

  return (
    <Box display='flex' flexDirection='column'>
      {message}
      <Box display='flex' gap={1} mt={1}>
        <BoldButton id='RefreshPageToast_RefreshButton' color='white' variant='text' onClick={handleRefresh}>
          {t('Refresh')}
        </BoldButton>
        <BoldButton id='RefreshPageToast_DismissButton' color='white' variant='text' onClick={handleDismiss}>
          {t('Dismiss')}
        </BoldButton>
      </Box>
    </Box>
  );
};

RefreshPageToast.defaultProps = {
  events: {
    onRefresh: () => {},
    onDismiss: () => {}
  }
};

RefreshPageToast.propTypes = {
  message: PropTypes.string,
  events: PropTypes.shape({
    onRefresh: PropTypes.func,
    onDismiss: PropTypes.func
  })
};

export default RefreshPageToast;
